import { render, staticRenderFns } from "./SearchExpensesGroups.vue?vue&type=template&id=727f12f2&"
import script from "./SearchExpensesGroups.vue?vue&type=script&lang=js&"
export * from "./SearchExpensesGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports